import { render, staticRenderFns } from "./NotificationsSettingsIcon.vue?vue&type=template&id=0a97e5e8&scoped=true"
import script from "./NotificationsSettingsIcon.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a97e5e8",
  null
  
)

export default component.exports